import * as React from 'react';

import { Dropdown } from '../../packages/Dropdown';
import { ISelectorValue, EGeoName } from '../../../types/share';

export interface IRegionSelectorProps {
  region: EGeoName;
  values: ISelectorValue<EGeoName>[];
  onChange(region: EGeoName): void;
}

export function RegionSelector({ region, values, onChange }: IRegionSelectorProps) {
  return <Dropdown value={region} values={values} onChange={onChange} />;
}
